import { Navigate } from "react-router-dom";

export const PublicRoute = ({ children, restricted, isLogged }) => {
  if (isLogged && restricted) {
    return <Navigate to="/" />;
  }

  return children;
};
